export class RevertCloseLeadInput {
    leadId: string;
    comments: string;
}
